import { Controller } from 'stimulus'

// Composer behaviour for the balance_px message inputs (thread reply + new-thread
// compose). Two jobs:
//   - Gate the Send button: it stays disabled until there's something to send —
//     non-whitespace text, or a staged attachment (balance-message-attachment
//     fills the hidden gcs_location input and re-fires this via an input event).
//   - Stop the double-send: once a submit fires, disable Send so a second tap
//     can't re-post the same message, and clear the input so the text doesn't
//     linger if the Turbo-stream replace of the composer is slow or missed.
export default class extends Controller<HTMLFormElement> {
  static targets = ['input', 'submit']

  declare readonly inputTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement

  connect() {
    this.sync()
  }

  // Enable Send only when there's something to send: caption/text, or a staged
  // attachment (a caption-less media message is valid).
  sync() {
    const hasText = this.inputTarget.value.trim().length > 0
    const stagedMedia = !!this.element.querySelector<HTMLInputElement>(
      'input[name="gcs_location"]',
    )?.value
    this.submitTarget.disabled = !hasText && !stagedMedia
  }

  submit() {
    // Guard against a double submit: Send stays disabled until the server
    // replaces this whole composer with a fresh, empty one.
    this.submitTarget.disabled = true
    // Clear *after* Turbo has serialized the form for the POST (next frame), so
    // the message still sends but the text never sticks in the box.
    window.requestAnimationFrame(() => {
      this.inputTarget.value = ''
    })
  }
}
